// This file is auto-generated. DO NOT EDIT.

export type CaptivePortalTemplate =
  | 'Basic'
  | 'Modern'
  | 'Minimal'
  | 'Corporate'
  | 'Split'
  | 'Compact';

export const CaptivePortalTemplateBasic: CaptivePortalTemplate = 'Basic' as const;
export const CaptivePortalTemplateModern: CaptivePortalTemplate = 'Modern' as const;
export const CaptivePortalTemplateMinimal: CaptivePortalTemplate = 'Minimal' as const;
export const CaptivePortalTemplateCorporate: CaptivePortalTemplate = 'Corporate' as const;
export const CaptivePortalTemplateSplit: CaptivePortalTemplate = 'Split' as const;
export const CaptivePortalTemplateCompact: CaptivePortalTemplate = 'Compact' as const;
